// #250: type ist offen (Plugin-Modell) — jeder format-valide String ist ein Channel-Type.
// Bekannte Typen sind nur Vorschläge (datalist im Dialog); die finale Prüfung macht der Master.
export interface CreateChannelInput {
  type: string;
  name: string;
  configJson: string; // raw JSON-String from textarea
}

// Vorschläge fürs type-Feld (datalist) — keine einschränkende Liste.
export const KNOWN_CHANNEL_TYPES = ["whatsapp", "telegram", "web", "email", "slack"] as const;
const CHANNEL_TYPE_RE = /^[a-z][a-z0-9-]*$/;

export interface UpdateChannelInput {
  name: string;
  configJson: string;
}

export interface ValidationError {
  field: "type" | "name" | "configJson";
  message: string;
}

export function validateCreateChannel(input: CreateChannelInput): ValidationError[] {
  const errors: ValidationError[] = [];
  if (input.name.length === 0) errors.push({ field: "name", message: "Pflichtfeld" });
  if (input.name.length > 120) errors.push({ field: "name", message: "max 120 Zeichen" });
  if (input.type.length < 2 || input.type.length > 32 || !CHANNEL_TYPE_RE.test(input.type)) {
    errors.push({ field: "type", message: "2–32 Zeichen, klein, beginnt mit Buchstabe (a–z, 0–9, -)" });
  }
  const c = parseConfig(input.configJson);
  if (!c.ok) errors.push({ field: "configJson", message: c.error });
  return errors;
}

export function validateUpdateChannel(input: UpdateChannelInput): ValidationError[] {
  const errors: ValidationError[] = [];
  if (input.name.length === 0) errors.push({ field: "name", message: "Pflichtfeld" });
  if (input.name.length > 120) errors.push({ field: "name", message: "max 120 Zeichen" });
  const c = parseConfig(input.configJson);
  if (!c.ok) errors.push({ field: "configJson", message: c.error });
  return errors;
}

export function parseConfig(json: string): { ok: true; value: Record<string, unknown> } | { ok: false; error: string } {
  const trimmed = json.trim();
  if (trimmed.length === 0) return { ok: true, value: {} };
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ok: false, error: "Config muss ein JSON-Objekt sein" };
    }
    return { ok: true, value: parsed as Record<string, unknown> };
  } catch (e) {
    return { ok: false, error: `Ungültiges JSON: ${(e as Error).message}` };
  }
}
